import React from 'react';

import { MdmObject, useGetObjectsByProjectQuery } from 'gql/generated/types';
import "leaflet/dist/leaflet.css";
import { useOutletContext } from 'react-router-dom';
import MapWrapper from '../components/MapWrapper';
import ObjectMapContent from '../components/ObjectMapContent';

const ObjectMap = () => {
  const projectId = useOutletContext<string>();
  const { data } = useGetObjectsByProjectQuery({ variables: { id: projectId }, skip: !projectId });
  return (
      <MapWrapper>
        <ObjectMapContent objects={(data?.mdmObjectsByProjectId ?? []) as MdmObject[]} />
      </MapWrapper>
  );
}

export default ObjectMap
